<template>
  <!--
    [ 레이아웃 옵션 / default : thum--right ]
    .thum--left
    .thum--right

    .columns--1
    .columns--2
    .columns--3
    .columns--4
    .columns--5
    .columns--5

    [ 크기옵션 / default :  ]
    .thum--xxxs
    .thum--xxs
    .thum--xs
    .thum--md
    .thum--sm
    .thum--lg
    .thum--xl
    .thum--xxl
    .thum--xxxl

    [ 히든 옵션 / default : hidden ]
    .view--checkbox
    .view--thum
    .view--list-number 
    .view--notice
    .view--list-secret
    .view--list-name
    .view--user-name
    .view--date
    .view--counter
    .view--text
    .view--comment
    .view--qna-comment
    .view--favorite
    .view--share
    .view--tag
    .view--arrow

    [ 호버 옵션 / default : 없음 ]
    .hover--grow
    .hover--opacity

    [ 간격 옵션 / default : spacing--sm ]
    .spacing--sm
    .spacing--md
    .spacing--lg

    [ 타이틀 크기 옵션 / default : spacing--sm ]
    .title--xxxs
    .title--xxs
    .title--xs
    .title--sm
    .title--md
    .title--lg
    .title--xl
    .title--xxl
    .title--xxxl

    [ 타이틀 두께 옵션 / default : spacing--sm ]
    .title--300
    .title--400
    .title--700
    .title--900
  -->

  <!-- <div class="list-type-a OPTION thum--xs thum--3:2"> -->
  <div class="list-type-a OPTION">
    <ul class="list clearfix">

      <li
        class="list__item clearfix"
        v-for="row in rows"
        :key="row.seq"
      >
        <a
          @click="goView(row.seq)"
          class="list__item-thum"
        >
          <div
            v-if="row.thumbnails.length > 0"
            class="list__item-thum-img"
            :style="`background-image:url(/api/boards/${row.boardId}/files/${row.uuid}/${row.thumbnails[0].fileName});`"
          >
          </div>
        </a>
        <div class="list__content">
          <a
            @click="goView(row.seq)"
            class="list__content-link clearfix"
          >
            <div class="list__head clearfix">
              <span class="list__checkbox">
                <form-checkbox
                  v-if="checkbox"
                  v-model="row.selected"
                  :true-value="true"
                  :false-value="false"
                ></form-checkbox>
              </span>
              <span class="list__notice">공지</span>
              <span class="list__name">{{row.filter}}</span>
              <span class="list__secret">
                <i class="material-icons">lock</i><span>비밀글</span>
              </span>
            </div>
            <div class="list__body">
              <strong class="list__title">
                <span class="list__number">1</span>{{row.title}}
              </strong>
              <!-- <p class="list__text">{{row.content}}</p> -->
              <div class="list__text">{{row.content | textOnly}} </div>

            </div>
          </a>
          <div class="list__foot clearfix">
            <!-- qna--complete 추가시 답변완료 -->
            <span class="list__qna-comment OPTION qna--complete">
              <i class="material-icons">comment</i> <strong class="">답변 미완료</strong>
            </span>
            <span class="list__comment">
              <i class="material-icons">comment</i>댓글 <strong>22개</strong>
            </span>
            <!-- is-selected 추가 후 .material-icons 글자를 favorite로 수정 -->
            <!-- <span class="list__favorite">
              <button-like></button-like>
            </span>
            <span class="list__share">
              <button-share></button-share>
            </span> -->

            <span class="list__user-name">by. 홍길동</span>
            <span class="list__date">2019.01.01</span>
            <span class="list__counter">1,111</span>
          </div>
          <div class="list__tag">
            <a class="list__tag-item"><span>#태그명</span></a>
            <a class="list__tag-item"><span>#태그명</span></a>
            <a class="list__tag-item"><span>#태그명</span></a>
            <a class="list__tag-item"><span>#태그명</span></a>
          </div>
        </div>
        <span class="list__arrow-deco">
          <i class="material-icons">arrow_forward</i>
        </span>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  props: {
    rows: { type: Array, required: true },
    goView: { type: Function, required: true },
    checkbox: { type: Boolean, default: false },
    currentRow: { type: Number, default: -1 },
    selectAll: { type: Function }
  },
  data () {
    return {
      // selected: false
    }
  },
  // methods: {
  //   all () {
  //     this.selected = !this.selected
  //     if (this.selectAll) {
  //       this.selectAll(this.selected)
  //     }
  //   }
  // },
  components: {
    FormCheckbox: () => import('@/component/ui2/form/FormCheckbox')
  }
}
</script>

